/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'
import CompanyServices from '../../../../services/company'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Perusahaan',
  },
  {
    name: '',
    label: 'Kepemilikan',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const CompanyPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({status: '', company_id: ''})
  const [submit, setSubmit] = useState(false)
  const [selected, setSelected] = useState<any>([])
  const [counter, setCounter] = useState<any>(1)
  const [inputs, setInputs] = useState([
    {
      name: 'company_name',
      label: 'Nama Perusahaan',
      type: '',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
    {
      name: 'ownership_id',
      label: 'Kepemilikan',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      validation: {},
      col: 12,
      options: [
        {
          name: 'Aktif',
          value: '1',
        },
        {
          name: 'Non-Aktif',
          value: '0',
        },
      ],
      getItemValue: 'name',
      getItemValueId: 'value',
      additional: '',
    },
  ])
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getCompanyHash,
    {
      ...query,
      page: pagination.page,
      sort_field: 'companies_id',
      per_page: pagination.per_page,
    },
    []
  )
  const [
    dataOwnership,
    loadingOwnership,
    emptyOwnership,
    refreshOwnership,
    isErrorOwnership,
    setLoadingOwnership,
  ] = useServices(
    MasterServices.getCompanyOwnership,
    {
      ...query,
      page: 1,
      sort_field: 'created_at',
      per_page: 100,
    },
    []
  )

  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useEffect(() => {
    let clone = inputs
    if (dataOwnership) {
      clone[1].options = dataOwnership?.data?.data
    }
    setInputs(clone)
  }, [dataOwnership])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const StatusComponent = (type: string) => {
    if (type === '0') {
      return (
        <Button
          variant='secondary'
          className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
        >
          Non-Aktif
        </Button>
      )
    }
    if (type === '1') {
      return (
        <Button
          className='shadow-none btn btn-sm btn-outline btn-outline-success'
          variant='outline'
        >
          Aktif
        </Button>
      )
    }
    if (type === '2') {
      return (
        <Button
          variant='secondary'
          className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
        >
          Banned
        </Button>
      )
    }
    if (type === '3') {
      return (
        <Button
          variant='secondary'
          className='shadow-none btn-sm btn-sm btn-outline btn-outline-primary'
        >
          Request Aktivasi
        </Button>
      )
    }
    if (type === '4') {
      return (
        <Button
          variant='secondary'
          className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
        >
          Ditolak
        </Button>
      )
    }
  }

  const handleApprove = async () => {
    try {
      setSubmit(true)
      await MasterServices.approveCompany(formValue)
      toast.success('Proses berhasil dilakukan')
      refresh()
    } catch (error) {
    } finally {
      refresh()
      setSubmit(false)
    }
  }

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleChangeStatus = async (id: any, status: any) => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Perusahaan ?')) {
        setLoading(true)
        await MasterServices.approveCompany({company_id: id, status: status})
        toast.success(`Status Perusahaan Berhasil Diperbarui`)
        refresh()
      }
    } catch (error) {
      refresh()
    }
  }

  const onSubmit = async (e: any) => {
    try {
      setSubmit(true)
      e?.preventDefault()
      await (formValue.id ? MasterServices.updateCompany : MasterServices.storeCompany)({
        ...formValue,
        ownership_id: formValue?.ownership_id?.company_ownerships_id,
      })
      toast.success(`Berhasil ${formValue.id ? 'Memperbarui' : 'Membuat'} Perusahaan`)
      toggle()
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  const handleCheck = (param: any) => {
    let newSelected: any = selected || []

    if (param === 'all') {
      if (selected?.length > 0) {
        newSelected = []
      } else {
        data?.data?.data?.forEach((item: any) => {
          return newSelected.push({
            company_id: item.company_id,
          })
        })
      }
    } else {
      const check = selected?.filter((f: any) => param === f.company_id)
      if (check.length < 1) {
        newSelected.push({
          company_id: param,
          status: 1,
        })
      } else {
        newSelected = selected?.filter((f: any) => f.company_id !== param)
      }
    }

    setSelected(newSelected)
    setCounter((val: any) => val + 1)
  }

  const actionBulkDelete = async (companiesId: any) => {
    try {
      setLoading(true)
      await CompanyServices.multipleDeleteCompany({companies_id: companiesId})
      toast.success(`Perusahaan Berhasil Dihapus`)
      return
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const handleBulkDelete = async () => {
    if (window.confirm('Yakin ingin hapus data?')) {
      let companiesId: any = []
      selected?.map((item: any) => {
        companiesId.push(item.company_id)
      })

      actionBulkDelete(companiesId)
    }
  }

  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Form Perusahaan</Modal.Title>
          </Modal.Header>
          <Form onSubmit={onSubmit}>
            <Modal.Body>
              <Row>{FormGenerator(inputs, formValue, onChange)}</Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={toggle} disabled={submit}>
                Batalkan
              </Button>
              <Button variant='primary' type='submit' disabled={submit}>
                {submit ? 'Loading' : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 6}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
            {selected.length > 0 && (
              <Row>
                <Col md={{span: 2}}>
                  <Button
                    onClick={() => handleBulkDelete()}
                    type='button'
                    className='mt-8 btn btn-secondary'
                  >
                    Hapus data terpilih ?
                  </Button>
                </Col>
              </Row>
            )}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>
                      <Form.Check
                        onClick={() => handleCheck('all')}
                        checked={
                          data?.data?.data.length === selected.length &&
                          data?.data?.data?.length > 0
                        }
                      />
                    </th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={4} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={4} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                        <td>
                          <Form.Check
                            onChange={() => handleCheck(item.company_id)}
                            checked={
                              selected.filter((f: any) => f.company_id === item.company_id)
                                .length > 0
                                ? true
                                : false
                            }
                          />
                        </td>
                          <td>{item.companies_name}</td>
                          <td>{item.company_ownership?.company_ownerships_name || '-'}</td>
                          <td>{StatusComponent(item.companies_status)}</td>
                          <td>
                            <Button
                              className='btn-sm'
                              onClick={() => {
                                setFormValue({
                                  id: item.companies_id,
                                  company_name: item.companies_name,
                                  ownership_id: item.company_ownership,
                                  status: item.companies_status,
                                })
                                toggle()
                              }}
                              disabled={item.companies_email ? true : false}
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const CompanyListed: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Data Perusahaan
      </PageTitle>
      <CompanyPage />
    </>
  )
}

export default CompanyListed
